/** The wording a catalogue option group or choice carries: its technical label and the customer's name for it. */
export interface CustomerWorded {
  label: string;
  customer_label?: string | null;
}

/**
 * What the customer reads for a group or choice: the dictionary's customer headline where one is written, else the
 * technical label. The server always sends `customer_label` (falling back to the label itself); this keeps fixtures
 * and older responses without it showing the label.
 */
export function customerLabelOf(term: CustomerWorded): string {
  return term.customer_label || term.label;
}
